import { useCurrentStateAndParams } from "@uirouter/react";

import { translate } from "app/filters/i18nFilter";
import { changeFilterItems } from "app/common/keyword-research/topics/topicsFilterConsts";
import type { IChangeFilterItems } from "app/components/filters-bar/change-filter/ChangeFilter";
import { EChangeFilterValues, ChangeFilter } from "app/components/filters-bar/change-filter/ChangeFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const getTrendsFilterItems = (): IChangeFilterItems[] =>
    changeFilterItems
        .filter((item) => item.id === EChangeFilterValues.Trending || item.id === EChangeFilterValues.DeTrending)
        .map(({ id, text, tooltip }) => ({
            id,
            text: translate(text),
            tooltip: translate(tooltip),
        }));

export const TrendsFilter = () => {
    const { trend } = useCurrentStateAndParams().params;

    const onTrendsFilterChange = (value: EChangeFilterValues) => {
        void proNavigator.updateParams({ trend: value });
    };

    return (
        <ChangeFilter
            onChangeFilterChange={onTrendsFilterChange}
            selectedValue={trend as EChangeFilterValues}
            changeFilterItems={getTrendsFilterItems()}
            defaultFilterText="website.topics.trends.filter.default.text"
        />
    );
};
